export default __webpack_public_path__ + "static/media/gridImage13.9c1d955e.jpg";